export default (visible = true) => [
  {
    field: 'seq',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 50,
    visible,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'thermometerNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 140,
    title: '温度计编号',
  },
  {
    field: 'v_tempRange',
    title: '温度区间',
    align: 'center',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'v_brandName',
    title: '品牌',
    align: 'center',
    minWidth: 100,
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
